import { useSyncExternalStore } from "react";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";

import { LoginPage } from "../features/auth/LoginPage";
import { authStore } from "../features/auth/authStore";
import { ChatListPage } from "../features/chats/ChatListPage";
import { ChatThreadPage } from "../features/chats/ChatThreadPage";

function subscribeToAuthStore(listener: () => void): () => void {
  return authStore.subscribe(() => {
    listener();
  });
}

function readHasSessionSnapshot(): boolean {
  return authStore.hasSession();
}

function useHasSession(): boolean {
  return useSyncExternalStore(subscribeToAuthStore, readHasSessionSnapshot, readHasSessionSnapshot);
}

function RootRedirect() {
  const hasSession = useHasSession();
  return <Navigate to={hasSession ? "/app" : "/login"} replace />;
}

function LoginGate() {
  return <LoginPage />;
}

function AuthGate() {
  const hasSession = useHasSession();
  if (!hasSession) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

export const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <RootRedirect />,
  },
  {
    path: "/login",
    element: <LoginGate />,
  },
  {
    path: "/app",
    element: <AuthGate />,
    children: [
      {
        index: true,
        element: <ChatListPage />,
      },
      {
        path: "chats/:chatID",
        element: <ChatThreadPage />,
      },
    ],
  },
], {
  future: {
    v7_relativeSplatPath: true,
  },
});
